export default __webpack_public_path__ + "static/media/sad-face.72b3054f.svg";